// extracted by mini-css-extract-plugin
export var cardTitle = "_ca-1";
export var commentBubble = "_ca-e";
export var commentForm = "_ca-a";
export var commentInput = "_ca-b";
export var commentLabel = "_ca-d";
export var commentPrompt = "_ca-9";
export var csatCard = "_ca-0";
export var feedbackSection = "_ca-7";
export var starDisabled = "_ca-6";
export var starEmpty = "_ca-5";
export var starFilled = "_ca-4";
export var starWrapper = "_ca-3";
export var starsContainer = "_ca-2";
export var submittedComment = "_ca-c";
export var thankYouText = "_ca-8";